module.exports = __webpack_public_path__ + "static/media/slide5.1f28547c.webp";